import ConfigurationContainer from './ConfigurationContainer';

export default ConfigurationContainer;
